import { render, staticRenderFns } from "./logcomment.vue?vue&type=template&id=0d44ff51&scoped=true"
import script from "./logcomment.vue?vue&type=script&lang=js"
export * from "./logcomment.vue?vue&type=script&lang=js"
import style0 from "./logcomment.vue?vue&type=style&index=0&id=0d44ff51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d44ff51",
  null
  
)

export default component.exports